// Every decide surface classifies approved-vs-edited through this one
// normalization; a divergent comparison would split the accept metrics.
export const normalizeDraftText = (text: string): string => text.trim().replace(/\s+/g, ' ')
